/* eslint-disable */
import { useLayoutEffect, useEffect, useState, useContext } from 'react'
import styles from './index.module.scss'
import Breadcrumb from '../../components/core/breadcrumb'
import PageTitle from '../../components/core/pageTitle'
import { Link } from 'react-router-dom'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'

const JoinOurFamily = ({ className }) => {
  const crumbs = [
    {
      link: '/',
      text: {
        AZ: 'Ana Səhifə',
        ENG: 'Home',
        RU: 'Главная страница',
        TR: 'Ana Sayfa',
      },
    },
    {
      link: '#',
      text: {
        ENG: 'Join our family',
        AZ: 'Ailəmizə qoşulun',
        RU: 'Присоединяйтесь к нашей семье',
        TR: 'Ailemize Katılın',
      },
    },
  ]
  const details = {
    AZ: 'Detallı baxın',
    ENG: 'See details',
    RU: 'Смотрите подробности',
    TR: 'Detaylı inceleyin',
  }
  const { language } = useContext(PageContext)
  const DEFAULT_DATA = {
    title: {
      AZ: 'Bizimlə İşləyin',
      ENG: 'Work With Us',
      RU: 'Работайте с нами',
      TR: 'Bizimle Çalışın',
    },
    description_az: '<p>Karyeranızı BPG Consulting komandasında qurun. Bizimlə birgə peşəkar inkişaf imkanlarından faydalanın.</p>',
    description_eng: '<p>Build your career with the BPG Consulting team. Benefit from professional development opportunities with us.</p>',
    description_ru: '<p>Постройте свою карьеру в команде BPG Consulting. Воспользуйтесь возможностями профессионального развития вместе с нами.</p>',
    description_tr: '<p>Kariyerinizi dinamik BPG Consulting ekibinde inşa edin. Bizimle birlikte profesyonel gelişim olanaklarından yararlanın.</p>',
  }
  const DEFAULT_HIRE = {
    title: {
      AZ: 'Məsafədən İşçi Axtaran Şirkətlər (Remote Hire)',
      ENG: 'Remote Hire (For Employers)',
      RU: 'Удаленный найм (для работодателей)',
      TR: 'Uzaktan Çalışan Arayan Şirketler (Remote Hire)',
    },
    description_az: '<p>Şirkətiniz üçün istənilən sahədə peşəkar, yoxlanılmış mütəxəssislərin məsafədən cəlb olunması və rəsmi idarə edilməsi.</p>',
    description_eng: '<p>Recruit and manage verified remote professionals for your company efficiently.</p>',
    description_ru: '<p>Привлечение и официальное управление проверенными удаленными специалистами для вашей компании.</p>',
    description_tr: '<p>Şirketiniz için herhangi bir alanda profesyonel ve doğrulanmış uzmanların uzaktan istihdamı ve resmi yönetimi.</p>',
  }
  const DEFAULT_WORK = {
    title: {
      AZ: 'Məsafədən Çalışmaq İstəyənlər (Remote Worker)',
      ENG: 'Remote Work (For Job Seekers)',
      RU: 'Удаленная работа (для соискателей)',
      TR: 'Uzaktan Çalışmak İsteyenler (Remote Worker)',
    },
    description_az: '<p>Məsafədən iş imkanları ilə tanış olun, bacarıqlarınıza uyğun layihələrdə və şirkətlərdə onlayn çalışmaq üçün müraciət edin.</p>',
    description_eng: '<p>Explore remote work opportunities and apply to work online on projects and companies matching your skills.</p>',
    description_ru: '<p>Ознакомьтесь с возможностями удаленной работы и подайте заявку на работу в компаниях.</p>',
    description_tr: '<p>Uzaktan çalışma olanaklarıyla tanışın, yeteneklerinize uygun projelerde ve şirketlerde çevrimiçi çalışmak için başvurun.</p>',
  }
  const [load, setLoad] = useState(true)
  const [data, setData] = useState(DEFAULT_DATA)
  const [hire, setHire] = useState(DEFAULT_HIRE)
  const [work, setWork] = useState(DEFAULT_WORK)
  useEffect(() => {
    (async () => {
      try {
        const [resPage, resHire, resWork] = await Promise.allSettled([
          PagesAPI.getJoinOurFamilyPage(),
          PagesAPI.getJoinOurFamilyHire(),
          PagesAPI.getJoinOurFamilyWork(),
        ])
        if (resPage.status === 'fulfilled' && resPage.value?.data?.title) {
          setData(resPage.value.data)
        }
        if (resHire.status === 'fulfilled' && resHire.value?.data?.title) {
          setHire(resHire.value.data)
        }
        if (resWork.status === 'fulfilled' && resWork.value?.data?.title) {
          setWork(resWork.value.data)
        }
      } catch (e) {
        console.warn('Using default JoinOurFamily data')
      }
    })()
  }, [])
  const hireBtnText = {
    AZ: 'Məsafədən İşçi Sifarişi Formu →',
    ENG: 'Remote Hire Form →',
    RU: 'Форма найма сотрудников →',
    TR: 'Uzaktan Çalışan Talep Formu →',
  }
  const workBtnText = {
    AZ: 'Məsafədən İşçi Müraciət Formu →',
    ENG: 'Remote Worker Form →',
    RU: 'Форма удаленной работы →',
    TR: 'Uzaktan Çalışan Başvuru Formu →',
  }
  return load ? (
    <section className={`${className} ${styles.container}`}>
      <div>
        <Breadcrumb crumbs={crumbs} />
        <PageTitle>{data?.title?.[language] || data?.title?.TR || data?.title?.AZ || ''}</PageTitle>
        <p
          dangerouslySetInnerHTML={{
            __html:
              language === 'AZ'
                ? data?.description_az
                : language === 'TR'
                ? (data?.description_tr || data?.description_az)
                : language === 'ENG'
                ? data?.description_eng
                : (data?.description_ru || data?.description_az),
          }}
        />
        <div className={styles.content}>
          <div className="bpg-card-neon">
            <h3>{hire?.title?.[language] || hire?.title?.TR || hire?.title?.AZ || ''}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  language === 'AZ'
                    ? hire?.description_az
                    : language === 'TR'
                    ? (hire?.description_tr || hire?.description_az)
                    : language === 'ENG'
                    ? hire?.description_eng
                    : (hire?.description_ru || hire?.description_az),
              }}
            />
            <Link to={'/remote-hire-step1'}>{hireBtnText[language] || hireBtnText.TR || hireBtnText.AZ}</Link>
          </div>
          <div className="bpg-card-neon">
            <h3>{work?.title?.[language] || work?.title?.TR || work?.title?.AZ || ''}</h3>
            <p
              dangerouslySetInnerHTML={{
                __html:
                  language === 'AZ'
                    ? work?.description_az
                    : language === 'TR'
                    ? (work?.description_tr || work?.description_az)
                    : language === 'ENG'
                    ? work?.description_eng
                    : (work?.description_ru || work?.description_az),
              }}
            />
            <Link to={'/remote-work-step1'}>{workBtnText[language] || workBtnText.TR || workBtnText.AZ}</Link>
          </div>
        </div>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default JoinOurFamily
